import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { useStore } from '~/app/store'
import { NotificationIndicator } from '~/shared/ui'

interface ExpressOrderIndicatorProps {
  className?: string
  variant?: 'dot' | 'count'
}

export const ExpressOrderIndicator = observer(
  ({ className, variant = 'count' }: ExpressOrderIndicatorProps) => {
    const { t } = useTranslation(['assembly'])
    const { warehousesStore } = useStore()
    const count = warehousesStore.getStatusCount('express')

    const label = t('assembly:expressDelivery')
    const displayCount = count > 99 ? '99+' : count

    return (
      <NotificationIndicator
        visible={count > 0}
        variant={variant}
        className={className}
        color="#DC2626"
        label={`${label}: ${count}`}
      >
        {displayCount}
      </NotificationIndicator>
    )
  },
)
